/** An explicit staging-only build, never a runtime query-string auth bypass. */
export const isThemeStudioDemoBuild = (): boolean =>
  process.env.REACT_APP_ENVIRONMENT === 'staging' &&
  process.env.REACT_APP_THEME_STUDIO_DEMO === 'true';
